import { render, staticRenderFns } from "./RegisterAsParentPage.vue?vue&type=template&id=1375f841&scoped=true"
import script from "./RegisterAsParentPage.vue?vue&type=script&lang=js"
export * from "./RegisterAsParentPage.vue?vue&type=script&lang=js"
import style0 from "./RegisterAsParentPage.vue?vue&type=style&index=0&id=1375f841&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1375f841",
  null
  
)

export default component.exports